export default __webpack_public_path__ + "static/media/blockchain.c785176c.jpg";